'use strict';

// RFC 9562 UUIDs: versions 1-8 with an RFC variant, plus the two reserved
// sentinel values recognized by class-validator's version-agnostic contract.
const UUID_PATTERN = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

/** @param {unknown} value @returns {value is string} */
function isUuid(value) {
  return typeof value === 'string' && UUID_PATTERN.test(value);
}

module.exports = { isUuid };
